import { toTitleCase } from '../utilities';

const SUB_COMPONENT_SEPARATOR = '__';

const COMPONENT_NAME_KEY_SPECIAL_CASES = Object.freeze({
  'Other Costs': 'other_cost',
});

export const deriveComponentKey = (componentName) => {
  return COMPONENT_NAME_KEY_SPECIAL_CASES[componentName]
    ? COMPONENT_NAME_KEY_SPECIAL_CASES[componentName]
    : componentName.replace(/\s/g, '_').toLowerCase();
};

export const extractComponentKey = (componentNameString) => {
  let parts = componentNameString.split(SUB_COMPONENT_SEPARATOR);
  return parts.length > 0 ? parts[0] : componentNameString;
};

export const extractSubComponentName = (componentNameString, separator = SUB_COMPONENT_SEPARATOR) => {
  let parts = (componentNameString || '').split(separator);
  return parts.length > 1 ? formatName(parts[1]) : componentNameString;
};

export const extractComponentName = (componentNameString) => {
  let parts = (componentNameString || '').split(SUB_COMPONENT_SEPARATOR);
  return parts.length > 0 ? formatName(parts[0]) : componentNameString;
};

export const formatName = (name) => {
  return toTitleCase(name.replace(/_/g, ' '));
};

export const extractComponentAndSubComponentName = (componentNameString) => {
  return {
    componentName: extractComponentName(componentNameString),
    subComponentName: extractSubComponentName(componentNameString),
  };
};

export const getDisplayName = (componentNameString) => {
  const componentAndSubComponentName = extractComponentAndSubComponentName(componentNameString);
  const { componentName, subComponentName } = componentAndSubComponentName;

  return (componentName || '').toLowerCase() !== (subComponentName || '').toLowerCase()
    ? `${componentName}/${subComponentName}`
    : `${componentName}`;
};



// WEBPACK FOOTER //
// ./src/utils/components.jsx